/* VikingsBrand Old Norse Translator — dictionary tool, not a sentence "AI translator".
   EN→ON: curated core (inline, verified against Zoëga 1910) + lazy full reverse index.
   ON→EN: lazy-loaded trimmed Zoëga (29,951 headwords). Younger Futhark rendering of
   ON words uses a documented simplified Viking-Age convention. Vanilla JS, no deps. */
(function () {
  'use strict';
  if (window.VBNorse) { return; }
  window.VBNorse = true;

  /* ---- i18n: a translated page sets window.VB_NT_I18N (sections/vb-norse-translator.liquid).
     de_index maps German search words to English core keys, gloss/phrases carry German meanings.
     Every string falls back to English, so the English page is unchanged. ---- */
  var I18N = window.VB_NT_I18N || {};
  function tr(k, en) { return (I18N[k] != null && I18N[k] !== '') ? I18N[k] : en; }
  var LOC_INDEX = I18N.de_index || null, LOC_GLOSS = I18N.gloss || {}, LOC_PHR = I18N.phrases || {};

  /* ---- ON → Younger Futhark (simplified Viking-Age convention; carvers varied) ----
     Digraphs first (ei/ey/au), þ/ð → ᚦ, nasal ǫ́/á → ᚬ, o/ó/ø/u/ú/v/w → ᚢ,
     e/é/i/í/j/y/ý → ᛁ, a/æ → ᛅ, word-final r → ᛦ (the old ʀ), doubles collapse. */
  var YF_DI = { ei: 'ᛅᛁ', ey: 'ᛅᚢ', au: 'ᛅᚢ' };
  var YF = {
    a:'ᛅ', 'á':'ᚬ', 'æ':'ᛅ', 'ǫ':'ᚬ', 'ö':'ᚬ', b:'ᛒ', c:'ᚴ', d:'ᛏ', 'ð':'ᚦ', e:'ᛁ', 'é':'ᛁ',
    f:'ᚠ', g:'ᚴ', h:'ᚼ', i:'ᛁ', 'í':'ᛁ', j:'ᛁ', k:'ᚴ', l:'ᛚ', m:'ᛘ', n:'ᚾ', o:'ᚢ', 'ó':'ᚢ',
    'ø':'ᚢ', 'œ':'ᚢ', p:'ᛒ', q:'ᚴ', r:'ᚱ', s:'ᛋ', t:'ᛏ', 'þ':'ᚦ', u:'ᚢ', 'ú':'ᚢ', v:'ᚢ',
    w:'ᚢ', x:'ᚴᛋ', y:'ᛁ', 'ý':'ᛁ', z:'ᛋ'
  };
  /* Elder Futhark + Anglo-Saxon Futhorc (same maps as the Rune Translator),
     with ON characters folded to their nearest Latin sounds first. */
  var EF = { a:'ᚨ',b:'ᛒ',c:'ᚲ',d:'ᛞ',e:'ᛖ',f:'ᚠ',g:'ᚷ',h:'ᚺ',i:'ᛁ',j:'ᛃ',k:'ᚲ',l:'ᛚ',m:'ᛗ',n:'ᚾ',o:'ᛟ',p:'ᛈ',q:'ᚲ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚹ',w:'ᚹ',x:'ᛉ',y:'ᛃ',z:'ᛉ' };
  var EF_DI = { th:'ᚦ', ng:'ᛜ' };
  var AF = { a:'ᚪ',b:'ᛒ',c:'ᚳ',d:'ᛞ',e:'ᛖ',f:'ᚠ',g:'ᚷ',h:'ᚻ',i:'ᛁ',j:'ᛄ',k:'ᚳ',l:'ᛚ',m:'ᛗ',n:'ᚾ',o:'ᚩ',p:'ᛈ',q:'ᚳ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚢ',w:'ᚹ',x:'ᛉ',y:'ᚣ',z:'ᛋ','æ':'ᚫ' };
  var AF_DI = { th:'ᚦ', ng:'ᛝ' };
  function foldForLatin(word, keepAe) {
    var w = word.toLowerCase()
      .replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o')
      .replace(/ú/g, 'u').replace(/ý/g, 'y').replace(/[ǫöø]/g, 'o').replace(/œ/g, 'o')
      .replace(/[þð]/g, 'th');
    return keepAe ? w : w.replace(/æ/g, 'ae');
  }
  function toFuthark(word, map, di, keepAe) {
    var w = foldForLatin(word, keepAe), out = '';
    for (var i = 0; i < w.length; i++) {
      var two = w.substr(i, 2);
      if (di[two]) { out += di[two]; i++; continue; }
      var ch = w[i];
      if (ch === ' ' || ch === '-') { out += ' '; continue; }
      if (map[ch] !== undefined) { out += map[ch]; }
    }
    return out;
  }
  function toYounger(word) {
    var w = word.toLowerCase(), out = '', prev = '';
    for (var i = 0; i < w.length; i++) {
      var two = w.substr(i, 2);
      if (YF_DI[two]) {
        if (YF_DI[two] !== prev) { out += YF_DI[two]; }
        prev = YF_DI[two]; i++; continue;
      }
      var ch = w[i];
      var rune = YF[ch];
      if (rune === undefined) { if (ch === ' ' || ch === '-') { out += ' '; prev = ''; } continue; }
      if (ch === 'r' && (i === w.length - 1 || w[i + 1] === ' ' || w[i + 1] === '-')) { rune = 'ᛦ'; }
      if (rune !== prev) { out += rune; }        /* runic convention: no doubled runes */
      prev = rune;
    }
    return out;
  }

  /* ---- tiny helpers ---- */
  /* Short-twig (Rök-style) = Younger Futhark with variant glyphs (Unicode SHORT-TWIG-* letters) */
  var ST_SWAP = { 'ᚬ':'ᚭ', 'ᚼ':'ᚽ', 'ᚾ':'ᚿ', 'ᛅ':'ᛆ', 'ᛋ':'ᛌ', 'ᛏ':'ᛐ', 'ᛒ':'ᛓ', 'ᛘ':'ᛙ', 'ᛦ':'ᛧ' };
  function toShortTwig(word) {
    return toYounger(word).replace(/[ᚬᚼᚾᛅᛋᛏᛒᛘᛦ]/g, function (g) { return ST_SWAP[g]; });
  }
  /* Medieval runerow (c. 1100–1500): dotted runes, a letter per Latin letter */
  var MED = { a:'ᛆ',b:'ᛒ',c:'ᛍ',d:'ᛑ',e:'ᛂ',f:'ᚠ',g:'ᚵ',h:'ᚼ',i:'ᛁ',j:'ᛁ',k:'ᚴ',l:'ᛚ',m:'ᛘ',n:'ᚾ',o:'ᚮ',p:'ᛔ',q:'ᚴ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚡ',w:'ᚡ',x:'ᚴᛋ',y:'ᛦ',z:'ᛋ','þ':'ᚦ','ð':'ᚧ','æ':'ᛅ','ö':'ᚯ','ø':'ᚯ' };
  function toMedieval(word) {
    var w = word.toLowerCase()
      .replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o')
      .replace(/ú/g, 'u').replace(/ý/g, 'y').replace(/ǫ/g, 'ö').replace(/œ/g, 'ö');
    var out = '';
    for (var i = 0; i < w.length; i++) {
      var ch = w[i];
      if (ch === ' ' || ch === '-') { out += ' '; continue; }
      if (MED[ch] !== undefined) { out += MED[ch]; }
    }
    return out;
  }

  /* shared with vb-quotes.js (Viking Quotes page) */
  window.VBNorse = { toYounger: toYounger, toShortTwig: toShortTwig, toMedieval: toMedieval, toFuthark: toFuthark, EF: EF, EF_DI: EF_DI, AF: AF, AF_DI: AF_DI };

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (html !== undefined) { n.innerHTML = html; }
    return n;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function copyText(txt, btn) {
    function done() {
      if (!btn) { return; }
      var old = btn.textContent;
      btn.textContent = tr('copied', 'COPIED ✓');
      setTimeout(function () { btn.textContent = old; }, 1400);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(done, function () { legacyCopy(txt); done(); });
    } else { legacyCopy(txt); done(); }
  }
  function legacyCopy(txt) {
    var ta = document.createElement('textarea');
    ta.value = txt; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus(); ta.setSelectionRange(0, ta.value.length);
    try { document.execCommand('copy'); } catch (e) { /* noop */ }
    document.body.removeChild(ta);
  }
  function normEn(w) { return w.toLowerCase().replace(/[^a-z\- ']/g, '').trim(); }
  function normOn(w) {
    return w.toLowerCase()
      .replace(/ǫ/g, 'ö').replace(/ø/g, 'ö').replace(/œ/g, 'æ').trim();
  }
  /* accent-blind key so "ulfr" finds "úlfr" */
  function foldOn(w) {
    return normOn(w).replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i')
      .replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ý/g, 'y')
      .replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/þ/g, 'th').replace(/ð/g, 'd');
  }

  function boot(root) {
    if (!root || root.dataset.vbNorseBoot === '1') { return; }
    root.dataset.vbNorseBoot = '1';
    var DATA = window.VB_NORSE_DATA || { core: {}, phrases: [] };
    var lookupUrl = root.dataset.lookupUrl, zoegaUrl = root.dataset.zoegaUrl;
    var LAZY = null, ZOEGA = null, zoegaFolded = null;
    /* in-flight fetches are shared, so keystrokes during the first 1-2 MB download don't refetch it;
       seq lets only the newest search write its results (an older, slower one is dropped) */
    var lazyP = null, zoegaP = null, seq = 0;
    var input = root.querySelector('[data-vb="nt-input"]');
    var results = root.querySelector('[data-vb="nt-results"]');
    var dirBtns = root.querySelectorAll('[data-vb-ntdir]');
    var goBtn = root.querySelector('[data-vb="nt-go"]');
    var dir = 'en';

    function fetchJson(url) {
      return fetch(url).then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.json();
      });
    }
    function getLazy() {
      if (LAZY) { return Promise.resolve(LAZY); }
      if (!lazyP) {
        lazyP = fetchJson(lookupUrl).then(function (j) { LAZY = j; return j; })
          .catch(function (e) { lazyP = null; throw e; }); /* a failed fetch may be retried */
      }
      return lazyP;
    }
    function getZoega() {
      if (ZOEGA) { return Promise.resolve(ZOEGA); }
      if (!zoegaP) {
        zoegaP = fetchJson(zoegaUrl).then(function (j) {
          zoegaFolded = new Array(j.length);
          for (var i = 0; i < j.length; i++) { zoegaFolded[i] = foldOn(j[i][0]); }
          ZOEGA = j;
          return j;
        }).catch(function (e) { zoegaP = null; throw e; });
      }
      return zoegaP;
    }

    /* ---------- localized search word → ON (core only), then English fallback ---------- */
    function normLoc(w) { return w.toLowerCase().replace(/[^a-zäöüßàâçéèêëîïôûùüÿñæœ\- ']/g, '').trim(); }
    function foldLoc(w) { return w.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss'); }
    function lookupLoc(word) {
      var k = normLoc(word);
      var keys = LOC_INDEX[k] || LOC_INDEX[foldLoc(k)];
      if (!keys) { return null; }
      var seen = {}, out = [];
      keys.forEach(function (key) {
        (DATA.core[key] || []).forEach(function (m) { if (!seen[m.on]) { seen[m.on] = 1; out.push(m); } });
      });
      return out.length ? out : null;
    }
    function lookupAny(word) {
      if (!LOC_INDEX) { return lookupEn(word); }
      var hit = lookupLoc(word);
      if (hit) { return Promise.resolve(hit); }
      return lookupEn(word).then(function (m) { if (m) { m = m.slice(); m.viaEnglish = true; } return m; });
    }
    /* ---------- EN → ON ---------- */
    function lookupEn(word) {
      var k = normEn(word);
      if (!k) { return Promise.resolve(null); }
      var hit = DATA.core[k];
      if (hit) { return Promise.resolve(hit); }
      /* naive singular: wolves→wolf handled by -es/-s strip attempts */
      var tries = [k];
      if (/ves$/.test(k)) { tries.push(k.replace(/ves$/, 'f')); }
      if (/ies$/.test(k)) { tries.push(k.replace(/ies$/, 'y')); }
      if (/es$/.test(k)) { tries.push(k.slice(0, -2)); }
      if (/s$/.test(k)) { tries.push(k.slice(0, -1)); }
      for (var i = 0; i < tries.length; i++) {
        if (DATA.core[tries[i]]) { return Promise.resolve(DATA.core[tries[i]]); }
      }
      return getLazy().then(function (L) {
        for (var i = 0; i < tries.length; i++) {
          if (L[tries[i]]) { return L[tries[i]]; }
        }
        return null;
      }).catch(function () { return null; });
    }
    var POS_LABEL = { m: 'noun, masculine', f: 'noun, feminine', n: 'noun, neuter', a: 'adjective', adj: 'adjective', v: 'verb', adv: 'adverb', pron: 'pronoun', conj: 'conjunction', prep: 'preposition' };
    if (I18N.pos) { Object.keys(I18N.pos).forEach(function (k) { POS_LABEL[k] = I18N.pos[k]; }); }
    function wordCard(en, matches) {
      var card = el('div', 'vb-nt-card');
      card.appendChild(el('span', 'vb-eyebrow', esc(en)));
      if (!matches) {
        card.appendChild(el('p', 'vb-nt-miss',
          tr('miss_en', 'Not in the dictionary. We only show words attested in Zoëga (1910), no guesses. Try a simpler synonym.')));
        return card;
      }
      if (matches.viaEnglish) { card.appendChild(el('p', 'vb-muted-note', esc(tr('miss_de_fallback', '')))); }
      matches.slice(0, 3).forEach(function (m, idx) {
        var lg = LOC_GLOSS[m.on];
        var gloss = lg && !matches.viaEnglish ? lg.g : m.gloss, note = lg && !matches.viaEnglish ? lg.n : m.note;
        var row = el('div', 'vb-nt-hit' + (idx === 0 ? ' is-first' : ''));
        var head = el('div', 'vb-nt-headline');
        head.appendChild(el('span', 'vb-nt-on', esc(m.on)));
        head.appendChild(el('span', 'vb-nt-pos', esc(POS_LABEL[m.pos] || m.pos)));
        if (m.core) { head.appendChild(el('span', 'vb-nt-badge', esc(tr('verified', 'verified')))); }
        row.appendChild(head);
        if (gloss && gloss.toLowerCase() !== (LOC_INDEX ? normLoc(en) : normEn(en))) { row.appendChild(el('p', 'vb-nt-gloss', esc(gloss))); }
        if (note) { row.appendChild(el('p', 'vb-nt-note', esc(note))); }
        var runes = toYounger(m.on);
        var rl = el('div', 'vb-nt-runes');
        var main = el('span', 'vb-nt-runeglyphs', esc(runes));
        main.title = tr('runes_title', 'Younger Futhark, the Viking-Age alphabet');
        rl.appendChild(main);
        var actions = el('span', 'vb-nt-copy');
        var b1 = el('button', 'vb-btn vb-btn--ghost', esc(tr('copy_word', 'COPY WORD')));
        b1.type = 'button';
        b1.addEventListener('click', function () { copyText(m.on, b1); });
        var b2 = el('button', 'vb-btn vb-btn--ghost', esc(tr('copy_runes', 'COPY RUNES')));
        b2.type = 'button';
        b2.addEventListener('click', function () { copyText(runes, b2); });
        actions.appendChild(b1); actions.appendChild(b2);
        rl.appendChild(actions);
        row.appendChild(rl);
        var alt = el('p', 'vb-nt-altrunes');
        var AL = I18N.alt_labels || ['Short-Twig', '· Medieval', '· Elder', '· Anglo-Saxon'];
        [[AL[0], toShortTwig(m.on)],
         [AL[1], toMedieval(m.on)],
         [AL[2], toFuthark(m.on, EF, EF_DI, false)],
         [AL[3], toFuthark(m.on, AF, AF_DI, true)]].forEach(function (pair) {
          alt.appendChild(el('span', 'vb-nt-altlabel', pair[0]));
          alt.appendChild(el('span', 'vb-nt-altglyphs', esc(pair[1])));
        });
        row.appendChild(alt);
        card.appendChild(row);
      });
      return card;
    }
    function phraseCard(p) {
      var card = el('div', 'vb-nt-phrase');
      var head = el('div', 'vb-nt-headline');
      head.appendChild(el('span', 'vb-nt-on', esc(p.on)));
      var lp = LOC_PHR[p.on] || {};
      head.appendChild(el('span', 'vb-nt-badge' + (p.tag === 'attested' ? '' : ' is-soft'), esc(p.tag === 'attested' ? tr('attested', 'attested') : tr('constructed', 'constructed'))));
      card.appendChild(head);
      card.appendChild(el('p', 'vb-nt-gloss', esc(lp.t || p.en)));
      var pnote = lp.t ? lp.n : p.note;
      card.appendChild(el('p', 'vb-nt-note', '<strong>' + esc(tr('source', 'Source:')) + '</strong> ' + esc(lp.s || p.src) + (pnote ? ' · ' + esc(pnote) : '')));
      var b = el('button', 'vb-btn vb-btn--ghost', esc(tr('copy', 'COPY')));
      b.type = 'button';
      b.addEventListener('click', function () { copyText(p.on, b); });
      card.appendChild(b);
      return card;
    }
    function runEn(q) {
      var my = ++seq;
      var words = q.split(/[\s,]+/).filter(Boolean).slice(0, 8);
      results.innerHTML = '';
      results.setAttribute('aria-busy', 'false');
      if (!words.length) { return; }
      /* whole-phrase match first: "i love you" should return the real phrase, not three words */
      if (words.length > 1 && DATA.phrases) {
        var clean = function (t) { return t.toLowerCase().replace(/\(.*?\)/g, '').replace(/[^a-zäöüß ]/g, '').replace(/\s+/g, ' ').trim(); };
        var qn = clean(q);
        var hits = DATA.phrases.filter(function (p) {
          var en = clean((LOC_PHR[p.on] && LOC_PHR[p.on].t) || p.en);
          return en === qn || en.indexOf(qn) === 0;
        });
        if (hits.length) {
          hits.slice(0, 3).forEach(function (p) { results.appendChild(phraseCard(p)); });
          results.appendChild(el('p', 'vb-muted-note vb-nt-multinote',
            tr('phrase_matched', 'Matched a real phrase from our phrasebook, grammar included. Word-for-word pieces below would lose the endings.')));
          return;
        }
      }
      /* localized index may hold multi-word entries ("offenes meer"): try the whole query first */
      if (LOC_INDEX && words.length > 1) {
        var whole = lookupLoc(q);
        if (whole) { results.appendChild(wordCard(q, whole)); return; }
      }
      results.setAttribute('aria-busy', 'true');
      Promise.all(words.map(lookupAny)).then(function (all) {
        if (my !== seq) { return; }
        results.setAttribute('aria-busy', 'false');
        results.innerHTML = '';
        words.forEach(function (w, i) { results.appendChild(wordCard(w, all[i])); });
        if (words.length > 1) {
          var found = all.filter(Boolean).length;
          if (found) {
            results.appendChild(el('p', 'vb-muted-note vb-nt-multinote',
              tr('wordforword', '⚠ These are word-for-word dictionary matches. Old Norse is a heavily inflected language: a real sentence changes every ending. For an honest phrase, use the attested phrasebook below.')));
          }
        }
      });
    }

    /* ---------- ON → EN ---------- */
    function runOn(q) {
      var my = ++seq;
      var k = normOn(q), fk = foldOn(q);
      results.innerHTML = '';
      results.setAttribute('aria-busy', 'false');
      if (!k) { return; }
      results.setAttribute('aria-busy', 'true');
      results.appendChild(el('p', 'vb-muted-note', tr('loading', 'Loading the dictionary (first search only)…')));
      getZoega().then(function (Z) {
        if (my !== seq) { return; }
        var exact = [], starts = [], contains = [];
        for (var i = 0; i < Z.length; i++) {
          var w = normOn(Z[i][0]), f = zoegaFolded[i];
          if (w === k || f === fk) { exact.push(Z[i]); }
          else if (w.indexOf(k) === 0 || f.indexOf(fk) === 0) { if (starts.length < 30) { starts.push(Z[i]); } }
          else if (k.length > 3 && f.indexOf(fk) > 0) { if (contains.length < 10) { contains.push(Z[i]); } }
        }
        var hits = exact.concat(starts, contains).slice(0, 8);
        results.setAttribute('aria-busy', 'false');
        results.innerHTML = '';
        if (!hits.length) {
          results.appendChild(el('p', 'vb-nt-miss', tr('miss_on', 'No headword found in Zoëga. Check the spelling. Accents are optional (ulfr finds úlfr).')));
          return;
        }
        hits.forEach(function (h) {
          var card = el('div', 'vb-nt-card');
          var head = el('div', 'vb-nt-headline');
          head.appendChild(el('span', 'vb-nt-on', esc(h[0])));
          head.appendChild(el('span', 'vb-nt-runeglyphs vb-nt-runes-inline', esc(toYounger(h[0]))));
          card.appendChild(head);
          card.appendChild(el('p', 'vb-nt-gloss', esc(h[1])));
          results.appendChild(card);
        });
        results.appendChild(el('p', 'vb-muted-note vb-nt-multinote',
          tr('zoega_credit_html', 'Definitions from Zoëga, <em>A Concise Dictionary of Old Icelandic</em> (1910), public domain.')));
      }).catch(function () {
        if (my !== seq) { return; }
        results.setAttribute('aria-busy', 'false');
        results.innerHTML = '';
        results.appendChild(el('p', 'vb-nt-miss', tr('load_error', 'Could not load the dictionary. Check your connection and try again.')));
      });
    }

    function run() {
      var q = input.value.trim();
      if (dir === 'en') { runEn(q); } else { runOn(q); }
      if (q) { try { history.replaceState(null, '', '#' + dir + ':' + encodeURIComponent(q)); } catch (e) { /* noop */ } }
    }
    var debounce;
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(run, 320);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    if (goBtn) { goBtn.addEventListener('click', run); }
    dirBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        dir = b.dataset.vbNtdir;
        dirBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        input.placeholder = dir === 'en' ? tr('placeholder_en', 'wolf, honor, my love…') : tr('placeholder_on', 'úlfr, drengr, orðstírr…');
        run();
      });
    });

    /* example chips */
    root.querySelectorAll('[data-vb-nt-try]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = chip.dataset.vbNtTry;
        if (chip.dataset.vbNtDir && chip.dataset.vbNtDir !== dir) {
          var target = root.querySelector('[data-vb-ntdir="' + chip.dataset.vbNtDir + '"]');
          if (target) { target.click(); }
        }
        input.value = v;
        run();
        input.focus();
      });
    });

    /* ---------- phrasebook ---------- */
    var scope = root.closest('.vb-runetool') || document;
    var phWrap = scope.querySelector('[data-vb="nt-phrases"]');
    if (phWrap && DATA.phrases) {
      DATA.phrases.forEach(function (p) { phWrap.appendChild(phraseCard(p)); });
    }

    /* deep link: #en:wolf / #on:ulfr */
    var h = '';
    try { h = decodeURIComponent(location.hash.slice(1)); } catch (e) { /* malformed %-escape in a shared link: ignore it */ }
    var dm = h.match(/^(en|on):(.+)$/);
    if (dm) {
      var db = root.querySelector('[data-vb-ntdir="' + dm[1] + '"]');
      if (db) { db.click(); }
      input.value = dm[2];
      run();
    }
  }

  function init() { document.querySelectorAll('#vb-norse').forEach(boot); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
